import Bugsnag from '@bugsnag/js'
import { Box } from '@mui/material'
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'
import React, { useState } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { deleteCustomCategory } from 'services/api/modules/payroll/payroll-config/customCategoryApi'

const RemoveCustomCategory = ({ children, props }) => {
  const [isModalOpen, setModalOpen] = useState(false)
  const handleOpen = () => {
    setModalOpen(true)
  }
  const handleClose = () => {
    setModalOpen(false)
  }
  const queryClient = useQueryClient()
  const { mutate: removeCustomItem } = useMutation(deleteCustomCategory, {
    onSuccess: () => {
      queryClient.invalidateQueries('getCustomCategory')
    },
    onError: (error) => {
      if (error.status === 422) {
        console.log(error)
      } else {
        Bugsnag.notify(error.data)
      }
    },
  })
  const handleRemove = () => {
    removeCustomItem({ id: props.id })
    setModalOpen(false)
  }
  return (
    <>
      <Box onClick={handleOpen}>{children}</Box>
      <AdxInfoModal
        open={isModalOpen}
        onClose={handleClose}
        handleClose={handleClose}
        muiIcon="error"
        iconColor="error.main"
        title="Are you sure you want to remove this?"
        subtitle="This item wont be available during payroll run"
        footerButtons
        firstBtnLabel={'Remove'}
        firstBtnHandle={handleRemove}
        secondBtnLabel={'Cancel'}
        secondBtnHandle={handleClose}
      ></AdxInfoModal>
    </>
  )
}
export default RemoveCustomCategory
